import type { DataTableHeader } from 'vuetify';
import { platformDictionary } from '@/stores';
import i18n from '@/plugins/i18n';

interface CurrencyDictionary {
    itemById: (id: number) => { symbol: string };
}

export function createTurnoverGamePageHeaders(currencyDictionary: CurrencyDictionary, displayedCurrencyId: number): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            key: 'data-table-expand',
            value: 'data-table-expand',
            align: 'center',
            sortable: false,
            minWidth: 28,
            width: 28,
            cellProps: { class: 'px-0' },
        },
        {
            title: t('turnoverEvent.date'),
            value: 'date',
            key: 'date',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.status'),
            value: 'status',
            key: 'statusId',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.league'),
            value: 'customLeagueName',
            key: 'customLeagueName',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.limitCategory'),
            value: 'customLeagueLimitsCategoryId',
            key: 'customLeagueLimitsCategoryId',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.home'),
            value: 'customTeamHomeName',
            key: 'customTeamHomeName',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.away'),
            value: 'customTeamAwayName',
            key: 'customTeamAwayName',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.minute'),
            value: 'time',
            key: 'time',
            align: 'center',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.score'),
            value: 'score',
            key: 'score',
            align: 'center',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.bets'),
            value: 'betCount',
            key: 'betCount',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: '',
            value: 'gameGrid',
            key: 'gameGrid',
            align: 'center',
            sortable: false,
            nowrap: true,
            minWidth: 0,
            width: 0,
            cellProps: { class: 'px-0' },
        },
        {
            title: currencyDictionary.itemById(displayedCurrencyId).symbol + ' ' + t('turnoverEvent.stake'),
            value: 'stakeSum',
            key: 'stakeSum',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: currencyDictionary.itemById(displayedCurrencyId).symbol + ' ' + t('turnoverEvent.pl'),
            value: 'balance',
            key: 'balance',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.users'),
            value: 'userCount',
            key: 'userCount',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('turnoverEvent.unsettledBets'),
            value: 'unsettledBetCount',
            key: 'unsettledBetCount',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: '',
            value: 'actions',
            key: 'actions',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 24,
            cellProps: { class: 'pl-2 pr-1' },
        },
    ];
}

export function createTurnoverGameDetailHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: t('bets.platform'),
            key: 'platform',
            value: (row: any) => platformDictionary.nameById(row.platform_id) || String(row.platform_id),
            sortable: true,
            nowrap: true,
            align: 'start',
        },
        { title: t('turnoverEvent.bets'), key: 'betCount', value: (row: any) => row.bet_count, sortable: true, nowrap: true, align: 'end' },
        { title: t('turnoverEvent.stake'), key: 'stakeSum', value: (row: any) => row.stake_sum, sortable: true, nowrap: true, align: 'end' },
        { title: t('turnoverEvent.pl'), key: 'balance', value: (row: any) => row.balance, sortable: true, nowrap: true, align: 'end' },
        { title: t('turnoverEvent.users'), key: 'userCount', value: (row: any) => row.user_count, sortable: true, nowrap: true, align: 'end' },
        {
            title: t('turnoverEvent.unsettledBets'),
            key: 'unsettledBetCount',
            value: (row: any) => row.unsettled_bet_count,
            sortable: true,
            nowrap: true,
            align: 'end',
        },
    ];
}
